import gql from 'graphql-tag';

const NEGOTIATION_INFO_FRAGMENT = gql`
  fragment NegotiationInfoFragment on NegotiationInfo {
    last_offer_user_id
    last_offer
    their_offer
    our_offer
  }
`;

export default NEGOTIATION_INFO_FRAGMENT;
